import { Component, OnInit } from "@angular/core";
import { MarketingCard } from "@rubbl-marketing";

@Component({
  selector: "app-home-renting-info",
  templateUrl: "./home-renting-info.component.html",
  styleUrls: ["./home-renting-info.component.scss"],
})
export class HomeRentingInfoComponent implements OnInit {
  rentingInfoCards: MarketingCard[] = [
    {
      iconClass: "icon-shopping-cart",
      title: "Quick & Easy Access",
      body:
        "Get real-time access to newer, never before available contractor-owned gear. Complete your rental in minutes with transparent pricing and quick checkout.",
    },
    {
      iconClass: "icon-warranty",
      title: "Vetted Gear",
      body:
        "All machines are pre-qualified with multiple 50-point inspections to ensure you get newer, well-maintained machines from a trusted community of owners.",
    },
    {
      iconClass: "icon-user",
      title: "Dedicated Support",
      body:
        "A dedicated, knowledgeable account manager will support you through every step of the rental process, ensuring your gear is always up and running.",
    },
  ];

  constructor() {}

  ngOnInit() {}
}
